<template>
    <transition name="fade">
        <div v-if="isShowOverlay"
             :class="$style.TheOverlay"
        />
    </transition>
</template>

<script setup>
    import { storeToRefs } from 'pinia'
    import { useOverlayStore } from '~/src/shared/pinia/useOverlayStore'

    defineProps({
        withoutHeader: {
            type: Boolean,
            default: false,
        },
    })

    const overlayStore = useOverlayStore()
    const { isShowOverlay } = storeToRefs(overlayStore)
</script>

<style
    lang="scss"
    module
>
    .TheOverlay {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
        width: 100vw;
        height: 100lvh;
        background-color: rgb(0 0 0 / 20%);
        pointer-events: none;
    }
</style>
